export const dashboardColors = ['#0090FE', '#AADAFF', '#A6F6E3', '#A6F6E3'];